import { BrowserRouter, Route, Routes } from "react-router-dom";
import Component from "./Component";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Component />} />
        <Route path="/:couponCode" element={<Component />} />
        {/* <Route path="*" element={<Error404page />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
